import axios from 'axios'
import store from '../store'
import Qs from 'qs'
import { Message, MessageBox } from 'element-ui'
import { getToken } from '@/utils/auth' // getToken from cookie
import router from '@/router'


// 创建一个axios实例
const service = axios.create({
    baseURL: process.env.BASE_URL,
    transformRequest: [function (data) {
        return Qs.stringify(data)
    }],
    timeout: 30000
});

// 添加请求拦截器
service.interceptors.request.use(config => {
    // 打开可能会报错 x-token不被允许
    config.headers['accessToken'] = getToken();
    config.headers['Accept-Language'] = localStorage.getItem("locale");
    return config;
}, error => {
    // 请求错误做些事
    return Promise.reject(error);
});
// 添加相应拦截器
service.interceptors.response.use(response => {
    const res = response.data;
    // 如果返回的状态码不是0 就主动报错
    if (res.code != 0) {
        // 正常报错
        if (res.code != 1200) {
            Message({
                message: res.msg,
                type: 'error',
                duration: 5 * 1000,
                showClose: true
            })
        }
        // token过期
        if (res.code === 1200) {
            Message({
                message: res.msg,
                type: 'error',
                duration: 5 * 1000,
                showClose: true
            })
            store.dispatch('FedLogOut').then(() => {
                router.push({ path: '/index' });
                store.dispatch("clickLogin", true);
            })
        }
        return Promise.reject(res.msg || 'error');
    } else {
        return res.data
    }
}, error => {
    Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000,
        showClose: true
    })
    return Promise.reject(error);
})

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js